module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-03-9f9cc04f8666285d233816acb1c5890c.webp";